import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    frameId: String,
    url: String,
    param: {
      type: String,
      default: 'community_space_id'
    }
  }

  connect() {
    this.handleChange = this.handleChange.bind(this)
    this.element.addEventListener('change', this.handleChange)
  }

  disconnect() {
    this.element.removeEventListener('change', this.handleChange)
  }

  handleChange() {
    const frame = document.getElementById(this.frameIdValue)
    if (!frame) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.paramValue, this.element.value)
    frame.src = url.toString()
  }
}
